export type PopsyAnimationName =
  | 'loading'
  | 'popsy-loading'
  | 'offline'
  | 'permission-storage'
  | 'permission-notification'
  | 'permission-location'
  | 'permission-camera'
  | 'permission-location-small'
  | 'permission-notification-small'
  | 'delivery-onboarding-step-1'
  | 'delivery-onboarding-step-2'
  | 'delivery-onboarding-step-3'
  | 'delivery-onboarding-step-4'
  | 'delivery-onboarding-step-5'
  | 'delivery-card-declined'
  | 'delivery-rider'
  | 'delivery-shield'
  | 'truck-animation'
  | 'contact-support'
  | 'insurance-question'
  | 'insurance'
  | 'confeti';

export interface PopsyAnimationInfo {
  name: string;
  path: string;
  placeholder: string;
  speed: number;
}

export const POPSY_LOTTIE_ANIMATIONS: {
  [animation: string]: PopsyAnimationInfo;
} = {
  loading: {
    name: 'loading',
    path: '/animations/loading/loading.json',
    placeholder: '/assets/animations/loading/loading.placeholder.svg',
    speed: 1,
  },
  'popsy-loading': {
    name: 'popsy-loading',
    path: '/animations/loading/popsy_loading.json',
    placeholder: '/assets/animations/loading/popsy_loading.placeholder.svg',
    speed: 1.5,
  },
  offline: {
    name: 'offline',
    path: '/animations/errors/offline.json',
    placeholder: '/assets/animations/errors/offline.placeholder.svg',
    speed: 1,
  },
  'permission-storage': {
    name: 'permission-storage',
    path: '/animations/permissions/storage.json',
    placeholder: '/assets/animations/permissions/storage.placeholder.svg',
    speed: 1,
  },
  'permission-notification': {
    name: 'permission-notification',
    path: '/animations/permissions/notifications.json',
    placeholder: '/assets/animations/permissions/notifications.placeholder.svg',
    speed: 1,
  },
  'permission-location': {
    name: 'permission-location',
    path: '/animations/permissions/location.json',
    placeholder: '/assets/animations/permissions/location.placeholder.svg',
    speed: 1,
  },
  'permission-camera': {
    name: 'permission-camera',
    path: '/animations/permissions/camera.json',
    placeholder: '/assets/animations/permissions/camera.placeholder.svg',
    speed: 1,
  },
  'permission-location-small': {
    name: 'permission-location-small',
    path: '/animations/permissions/small/location.json',
    placeholder: '/assets/animations/permissions/small/location.placeholder.svg',
    speed: 1,
  },
  'permission-notification-small': {
    name: 'permission-notification-small',
    path: '/animations/permissions/small/notifications.json',
    placeholder: '/assets/animations/permissions/small/notifications.placeholder.svg',
    speed: 1,
  },
  'delivery-onboarding-step-1': {
    name: 'delivery-onboarding-step-1',
    path: '/animations/delivery-onboarding/step-1.json',
    placeholder: '/assets/animations/delivery-onboarding/step-1.placeholder.svg',
    speed: 0.5,
  },
  'delivery-onboarding-step-2': {
    name: 'delivery-onboarding-step-2',
    path: '/animations/delivery-onboarding/step-2.json',
    placeholder: '/assets/animations/delivery-onboarding/step-2.placeholder.svg',
    speed: 0.5,
  },
  'delivery-onboarding-step-3': {
    name: 'delivery-onboarding-step-3',
    path: '/animations/delivery-onboarding/step-3.json',
    placeholder: '/assets/animations/delivery-onboarding/step-3.placeholder.svg',
    speed: 0.5,
  },
  'delivery-onboarding-step-4': {
    name: 'delivery-onboarding-step-4',
    path: '/animations/delivery-onboarding/step-4.json',
    placeholder: '/assets/animations/delivery-onboarding/step-4.placeholder.svg',
    speed: 0.5,
  },
  'delivery-onboarding-step-5': {
    name: 'delivery-onboarding-step-5',
    path: '/animations/delivery-onboarding/step-5.json',
    placeholder: '/assets/animations/delivery-onboarding/step-5.placeholder.svg',
    speed: 0.5,
  },
  'delivery-card-declined': {
    name: 'delivery-card-declined',
    path: '/animations/deliveries/delivery_card_declined.json',
    placeholder: '/assets/animations/deliveries/delivery_card_declined.placeholder.svg',
    speed: 1,
  },
  'delivery-rider': {
    name: 'delivery-rider',
    path: '/animations/deliveries/rider.json',
    placeholder: '/assets/animations/deliveries/rider.placeholder.svg',
    speed: 1,
  },
  'delivery-shield': {
    name: 'delivery-shield',
    path: '/animations/deliveries/shield.json',
    placeholder: '/assets/animations/deliveries/shield.placeholder.svg',
    speed: 0.5,
  },
  'truck-animation': {
    name: 'truck-animation',
    path: '/animations/deliveries/truck_animation.json',
    placeholder: '/assets/animations/deliveries/truck_animation.placeholder.jpg',
    speed: 1,
  },
  'contact-support': {
    name: 'contact-support',
    path: '/animations/deliveries/contact_support.json',
    placeholder: '/assets/animations/deliveries/contact_support.placeholder.svg',
    speed: 1,
  },
  'insurance-question': {
    name: 'insurance-question',
    path: '/animations/deliveries/insurance_question.json',
    placeholder: '/assets/animations/deliveries/insurance_question.placeholder.svg',
    speed: 1,
  },
  insurance: {
    name: 'insurance',
    path: '/animations/deliveries/insurance.json',
    placeholder: '/assets/animations/deliveries/insurance.placeholder.svg',
    speed: 1,
  },
  confeti: {
    name: 'confeti',
    path: '/animations/deliveries/confeti.json',
    placeholder: '',
    speed: 1,
  },
};

export const getLottieAnimationInfo = (
  name?: string | null,
  countryCode?: string | null
): PopsyAnimationInfo | null => {
  if (name) {
    const animationData: PopsyAnimationInfo | null =
      POPSY_LOTTIE_ANIMATIONS[name] || null;
    if (
      `${countryCode || ''}`.toLowerCase() === 'sa' &&
      animationData &&
      name.indexOf('delivery-onboarding') !== -1
    ) {
      return {
        ...animationData,
        path: `${animationData.path}`.replace('.json', '-SA.json'),
        placeholder: `${animationData.path}`.replace(
          '.placeholder.svg',
          '-SA.placeholder.svg'
        ),
      };
    }
    return animationData;
  }
  return null;
};
